import '../../styles.global.css';
import '../../assets/styles/Paginator.module.css';

var styles = {"baseFont":"wru__Paginator__baseFont","container":"wru__Paginator__container","baseColor":"wru__Paginator__baseColor","baseFontFamily":"wru__Paginator__baseFontFamily","paginator":"wru__Paginator__paginator","previous":"wru__Paginator__previous","next":"wru__Paginator__next","isDisabled":"wru__Paginator__isDisabled","list":"wru__Paginator__list","item":"wru__Paginator__item","isActive":"wru__Paginator__isActive","hellip":"wru__Paginator__hellip","spinner":"wru__Paginator__spinner"};

export { styles as default };
//# sourceMappingURL=Paginator.module.scss.js.map
